import { Heading } from './Typography';

export const ErrorMessageTitle = ({ text }: { text: string }) => (
  <Heading as="h2" textAlign="center">
    {text}
  </Heading>
);
